import { useDispatch, useSelector } from "react-redux";
import { chatOperations } from "redux/modules/chat";
import { emailOperations } from "redux/modules/email";
import { IApplicationState } from "redux/types";

/**
 * A hook that provides functions for toggling email and chat.
 * @returns An object containing the functions for toggling email and chat.
 */
export const useChatEmailToggles = () => {
    const dispatch = useDispatch();

    const isChatEnabled = useSelector((state: IApplicationState) => state.chat.enabled);
    const isEmailEnabled = useSelector((state: IApplicationState) => state.email.enabled);

    /**
     * Toggle chat on or off. If the correct state is already set, nothing is done.
     * @param enableChat A boolean indicating if the chat should be enabled.
     */
    const toggleChat = (enableChat: boolean) => {
        if (enableChat && !isChatEnabled) {
            dispatch(chatOperations.toggleChatOn());
            return;
        }

        if (!enableChat && isChatEnabled) {
            dispatch(chatOperations.toggleChatOff());
            return;
        }
    };

    /**
     * Toggle email on or off. If the correct state is already set, nothing is done.
     * @param enableEmail A boolean indicating if the email should be enabled.
     */
    const toggleEmail = (enableEmail: boolean) => {
        if (enableEmail && !isEmailEnabled) {
            dispatch(emailOperations.toggleEmail(true));
            return;
        }

        if (!enableEmail && isEmailEnabled) {
            dispatch(emailOperations.toggleEmail(false));
            return;
        }
    };

    return { toggleChat, toggleEmail };
};
